import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@lt/components';
import { getIsMobile } from 'src/store/view/selectors';
import { isLastReview } from 'src/store/reviews/selectors';
import { getHasReviewsSection } from '../../store/selectors/view';
import {
  scrollToReviewsAction,
  showPageAction,
} from '../../store/actions/view';
import { HOTEL_MOBILE_PAGES } from '../../constants';

const ShowReviewsButton = ({
  hasReviewsSection,
  onClickDesktop,
  onClickMobile,
  label,
  isMobile,
}) =>
  hasReviewsSection && (
    <StyledButton
      isMobile={isMobile}
      onClick={isMobile ? onClickMobile : onClickDesktop}
    >
      {label}
    </StyledButton>
  );

ShowReviewsButton.defaultProps = {
  label: 'Перейти к отзывам',
  isMobile: false,
};

ShowReviewsButton.propTypes = {
  label: PropTypes.string,
  isMobile: PropTypes.bool,
  onClickDesktop: PropTypes.func.isRequired,
  onClickMobile: PropTypes.func.isRequired,
};

const StyledButton = styled(Button)`
  margin: 10px 0;
  width: auto;
  height: 34px;
  font-size: ${(props) => (props.isMobile ? '13' : '14')}px;
`;

const mapStateToProps = (state) => ({
  isMobile: getIsMobile(state),
  hasReviewsSection: getHasReviewsSection(state),
  label: isLastReview(state) ? 'Показать все отзывы' : 'Перейти к отзывам',
});

const mapDispatchToProps = (dispatch) => ({
  onClickDesktop: () => dispatch(scrollToReviewsAction()),
  onClickMobile: () => dispatch(showPageAction(HOTEL_MOBILE_PAGES.REVIEWS)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(ShowReviewsButton));
